import type { DomainMapper } from '../types';

const no: DomainMapper = {
  countryCode: 'no',
  currency: 'NOK',
  dataAreaId: 'no32',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/NO.svg',
  languagePrimary: true,
  locale: 'no',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-no.xml',
  storyblokBasePath: 'no',
  url: 'https://kahrs-stage.iveo.store/no',
  algoliaIndex: 'b2b-no-nb-NO-products',
  algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1352,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1352,
    algoliaIndex: 'b2b-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-no.xml',
  },
  b2c: {
    enabled: false,
    purchaseEnabled: false,
    storyblokBasePath: '',
    applicationId: 1352,
    algoliaIndex: 'b2b-no-nb-NO-products',
    algoliaIndexAutocomplete: 'b2b-no-nb-NO-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-no-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: true,
  norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech',
} as DomainMapper;

export default no;
